import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import ContainerForm from "./ContainerForm";
import axios from "../../../utils/axios";

export default function ProcedureReviewSimple({ canGoBack, handleBack, handleNext, children, docId }) {
  const documento = useSelector(({ documento }) => documento.documento);
  const { transaction } = useParams();

  const handleDownloadWord = () => {
    axios({
      url: `/api/word/${transaction}/${docId}`,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const fileNameHeader = "x-suggested-filename";
        const suggestedFileName = response.headers[fileNameHeader];
        let effectiveFileName = suggestedFileName === undefined ? `Doc${transaction}.docx` : suggestedFileName;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if ("undefined.docx" === effectiveFileName) {
          effectiveFileName = `Doc${transaction}.docx`;
        }
        link.setAttribute("download", effectiveFileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        alert("Hubo un error al intentar descargar");
      });
  };

  const footer = (
    <div className="gd-review-footer">
      <div className="gd-review-note">
        <InfoOutlinedIcon style={{ fontSize: 18 }} />
        <div>
          <strong>Revisa con atención</strong>
          <span>
            Una vez que presiones <em>Continuar</em>, no podrás hacer correcciones al documento.
          </span>
        </div>
      </div>

      <div className="gd-review-actions">
        {canGoBack && (
          <button className="gd-btn gd-btn-ghost" onClick={handleBack} type="button">
            <ArrowBackIcon style={{ fontSize: 18 }} />
            <span>Retroceder</span>
          </button>
        )}

        <button className="gd-btn gd-btn-outline" onClick={handleDownloadWord} type="button">
          <GetAppIcon style={{ fontSize: 18 }} />
          <span>Descargar Word</span>
        </button>

        <button className="gd-btn gd-btn-primary" onClick={handleNext} type="button">
          <span>Continuar con el trámite</span>
          <ArrowForwardIcon style={{ fontSize: 18 }} />
        </button>
      </div>
    </div>
  );

  return (
    <ContainerForm documento={documento} footer={footer}>
      {children}
    </ContainerForm>
  );
}
